'use strict';
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _WarningFilled = _interopRequireDefault(require('./lib/icons/WarningFilled'));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _WarningFilled;
  exports.default = _default;
  module.exports = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@ant-design/icons/WarningFilled.js
// module id = 1016
// module chunks = 0